(function(){
  var root = document.querySelector('[data-tpk2]');
  if(!root) return;

  function updateCartCount(count){
    var selectors = [
      '[data-cart-count]',
      '.cart-count',
      '.cart-count-bubble span',
      '.header__cart-count',
      '.site-header__cart-count',
      'a[href*="/cart"] .count',
      'a[href="/cart"] .count'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        el.textContent = String(count);
        el.classList.remove('hidden');
        el.style.display = '';
      });
    });
    try{ document.dispatchEvent(new CustomEvent('cart:updated',{ detail:{ item_count:count } })); }catch(e){}
    try{ window.dispatchEvent(new CustomEvent('cart:updated',{ detail:{ item_count:count } })); }catch(e){}
    try{ document.dispatchEvent(new Event('cart:refresh')); }catch(e){}
    try{ document.dispatchEvent(new Event('cart:change')); }catch(e){}
  }

  function refreshCart(){
    return fetch('/cart.js',{ credentials:'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if(cart && typeof cart.item_count !== 'undefined'){
          updateCartCount(cart.item_count);
        }
        return cart;
      });
  }

  function addToCart(variantId){
    return fetch('/cart/add.js',{
      method:'POST',
      headers:{ 'Content-Type':'application/json','Accept':'application/json' },
      credentials:'same-origin',
      body:JSON.stringify({
        id:Number(variantId),
        quantity:1,
        properties:{
          '_source': 'perfect-kit',
          '_source_product': window.location.pathname.split('/products/')[1] || ''
        }
      })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(err){ throw err; });
      return r.json();
    });
  }

  root.querySelectorAll('[data-atc]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      var vid = btn.getAttribute('data-variant-id');
      if(!vid) return;
      var prevText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      addToCart(vid)
        .then(function(){ return refreshCart(); })
        .then(function(){
          btn.textContent = 'Added';
          window.setTimeout(function(){
            btn.textContent = prevText;
            btn.disabled = false;
          }, 900);
        })
        .catch(function(){
          btn.textContent = 'Error';
          window.setTimeout(function(){
            btn.textContent = prevText;
            btn.disabled = false;
          }, 1100);
        });
    });
  });
})();